// extracted by mini-css-extract-plugin
export default {"showCard":"CustomJudgementTwo_showCard__ldmlM","editStyle":"CustomJudgementTwo_editStyle__PwzxG","font20":"CustomJudgementTwo_font20__CUvOX"};